import { Helmet } from 'react-helmet-async';

import { LoginForm } from '../../forms/Login';
import { buildDocumentTitle } from '../../utils/document-title.util';

export const LoginPage = () => (
  <>
    <Helmet>
      <title>{buildDocumentTitle('Connexion')}</title>
    </Helmet>
    <LoginForm />
  </>
);
